export { LikeIcon } from "./LikeIcon";
